
import Vue from 'vue';
import msDataProvider from "@/services/msDataProvider";
import {LOGIN_TYPE_KEY, MSUITE_LOCAL_KEY} from "@/constant/login";
import loginService from "@/services/loginService";
import LocalStorage from "@/services/localStorage";
import AutoStartAppService from "@/services/autoStartAppService";

export default Vue.extend({
  name: "SwitchServerModal",
  props: ["value", "currentServerName"],
  data() {
    return {
      listServerName: [],
      selectedServer: "",
      loading: false
    }
  },
  methods: {
    async setServerName() {
      try {
        this.loading = true;
        await msDataProvider.executeCommand(
            "backendServerNameSetCurrentValue",
            this.selectedServer
        );
        await this.prepare();
        await AutoStartAppService.resetStateAutoStart();
        location.reload();
      } catch (e) {
        return e;
      } finally {
        this.loading = false;
      }
    },

    async prepare(params = {}) {
      try {
        const response = await msDataProvider.executeCommand(
            "authenPrepareLogin",
            params
        );
        if (response.new_backend_server_name) {
          location.reload();
          return;
        }
        loginService.setPrepareLoginResponse(response);
        if (response.error_info.error_code) {
          return;
        }
        this.setDefaultLoginType(response);
        this.$router.push("/prepare").catch((e) => e);
      } catch (e) {
        return e;
      }
    },

    setDefaultLoginType(prepareData) {
      const listLoginType = LocalStorage.getItem(LOGIN_TYPE_KEY);
      if (listLoginType) {
        const loginType = listLoginType[this.currentServerName];
        if (!prepareData.availableMethods.find(method => method.name === loginType)) {
          LocalStorage.setItem(LOGIN_TYPE_KEY, {
            ...listLoginType,
            [this.currentServerName]: MSUITE_LOCAL_KEY
          });
        }
      } else {
        LocalStorage.setItem(LOGIN_TYPE_KEY, {
          [this.currentServerName]: MSUITE_LOCAL_KEY
        });
      }

    },

    close() {
      this.$emit("close");
    }
  },

  async created() {
    this.selectedServer = this.currentServerName;
    const backendServerNameAllValues = await msDataProvider.executeCommand('backendServerNameGetAllValues');
    if (backendServerNameAllValues && backendServerNameAllValues.length) {
      this.listServerName = backendServerNameAllValues;
    }
  }
})
